// extracted by mini-css-extract-plugin
export default {"fqdn":"FqdnCell-fqdn_AD6np","textBreak":"FqdnCell-textBreak_elahz","fqdnContainer":"FqdnCell-fqdnContainer_g4vZR","tld":"FqdnCell-tld_atCps"};